// this probably makes sense here because we always load nut?
// https://v6.vite.dev/guide/backend-integration.html
// vite tells us to include this
import 'vite/modulepreload-polyfill'; // eslint-disable-line import/no-unresolved

import './polyfills'; // We want this to run before our babel polyfill
import '@babel/polyfill';
import 'cross-fetch/polyfill';

// Global imports used primarily in legacy code
import React from 'react';
import ReactDOM from 'react-dom';
import {Quill} from 'react-quill';
import 'favico.js';

import moment from 'moment';
// @ts-expect-error
import * as Visibility from 'visibilityjs';

import * as keys from 'shells/utils/keys';

import Backbone from 'backbone';
import numeral from 'numeral';
import {Collections} from 'nutshell-core/collections';
// replaces webpack expose-loader
import underscore from 'underscore';

// sidestep recursive css modules problem for now
import './ui/assets/css/shared/custom-properties.css';
import './ui/assets/css/shared/shepherd.css';
import './client_modules/shells/react/components/shared-styles.css';
import 'setimmediate';

import * as Phone from './phone';
import {pollForNotifications} from './poll-for-notifications';
import {store} from './store';
// @ts-expect-error
import * as ui from './ui/ui';
// @ts-expect-error
import {writeLocalStorage, readLocalStorage} from './util/localStorage';

window.React = React;
window.ReactDOM = ReactDOM;
// @ts-expect-error
window.Visibility = Visibility;

// @ts-expect-error
window.Quill = Quill;
// @ts-expect-error
window.moment = moment;
// @ts-expect-error
window.underscore = underscore;
// @ts-expect-error
Backbone.$ = window.jQuery;
window.numeral = numeral;

const {requestCollection, updateCollection} = Collections;

// @ts-expect-error
window.Nut = {
    isWebClient: true,
    actions: {
        requestCollection,
        updateCollection,
    },
    dispatch: store.dispatch.bind(store),
    keys,
    Phone,
    ui,
    writeLocalStorage,
    readLocalStorage,
    pollForNotifications,
};
